export { FAQs } from './FAQs';
export { type FAQsProps } from './FAQs';
export { faqsSchema } from './schema';
